// extracted by mini-css-extract-plugin
export default {"tools":"Operations_tools__0-bbU","container":"Operations_container__lRzoL","btn":"Operations_btn__3yLkp","menu":"Operations_menu__fBR4p","menuItem":"Operations_menuItem__xyPlA"};